// src/components/BlogList.jsx

import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export default function BlogList() {
  const [posts, setPosts] = useState([])

  useEffect(() => {
    fetch('/postsIndex.json')
      .then(res => res.json())
      .then(setPosts)
      .catch(console.error)
  }, [])

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-4xl font-bold mb-8">Blog</h1>

      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map(post => (
          <Link
            key={post.slug}                       // ← unique key per card
            to={`/blog/${post.slug}`}
            className="block bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden"
          >
            {/* Optional cover image */}
            {post.cover_image_url && (
              <img
                key={`${post.slug}-img`}         // ← another unique key
                src={post.cover_image_url}
                alt={post.title}
                className="w-full h-48 object-cover"
              />
            )}

            <div key={`${post.slug}-content`} className="p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                {post.title}
              </h2>
              <p className="text-gray-600 mb-4">{post.excerpt}</p>
              <p className="text-sm text-gray-500">
                {new Date(post.date).toLocaleDateString()}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}